import { MailInfo } from './../../model/mail-info.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-other-candidate-button',
  templateUrl: './other-candidate-button.component.html',
  styleUrls: ['./other-candidate-button.component.scss']
})
export class OtherCandidateButtonComponent implements OnInit {
  @Input() workerMail: MailInfo;
  @Input() projectMail: MailInfo;
  @Input() baseMailType: string;
  @Input() fromListPage: boolean = false;
  component: { id: number };

  constructor() {}

  ngOnInit() {}

  // 詳細画面へ遷移
  goToDetailPage(): void {
    if (this.baseMailType === 'project') {
      window.open('/matching/projects/' + this.projectMail.id, '_blank');
    } else {
      window.open('/matching/workers/' + this.workerMail.id, '_blank');
    }
  }
}
